import { Capacitor } from '@capacitor/core';

const env = process.env;

/** True inside the Capacitor (Android/iOS) app, false in a browser. */
export const isNative = (): boolean => Capacitor.isNativePlatform();

/** True in an Android debug build (assembleDebug): MainActivity exposes it as window.AndroidBuild. */
const isDebugBuild = (): boolean => {
    try {
        return Boolean((window as any).AndroidBuild?.isDebug());
    } catch {
        return false;
    }
};

export const config = {
    /** AdSense publisher id, e.g. ca-pub-1234567890123456. Unset = no web ads. */
    adsenseClient: env.REACT_APP_ADSENSE_CLIENT || '',
    adsenseFooterSlot: env.REACT_APP_ADSENSE_FOOTER_SLOT || '',
    adsenseBreakSlot: env.REACT_APP_ADSENSE_BREAK_SLOT || '',
    /** Show placeholder ads when no ad network is configured (development only). */
    adsPreview: env.REACT_APP_ADS_PREVIEW === 'true',
    adsenseTest: env.REACT_APP_ADSENSE_TEST === 'true',

    // arcana-beforereveal (rewarded interstitial) and arcana-footer (banner). Test ads show unless a production build says otherwise.
    admobRewardedId:
        env.REACT_APP_ADMOB_REWARDED_ID ||
        'ca-app-pub-8117664763681865/2955093057',
    admobBannerId:
        env.REACT_APP_ADMOB_BANNER_ID ||
        'ca-app-pub-8117664763681865/3556149276',
    admobTesting:
        isDebugBuild() ||
        (env.REACT_APP_ADMOB_TESTING !== undefined &&
        env.REACT_APP_ADMOB_TESTING !== ''
            ? env.REACT_APP_ADMOB_TESTING !== 'false'
            : env.NODE_ENV !== 'production'),

    donateUrl: env.REACT_APP_DONATE_URL || 'https://ko-fi.com/gagoworks',
    pixUrl:
        env.REACT_APP_PIX_URL || 'https://link.mercadopago.com.br/gagoworks',

    /** The one-time "no ads" product, a non-consumable in Play Console / App Store Connect. */
    lifetimeProductId:
        env.REACT_APP_LIFETIME_PRODUCT_ID || 'works.gago.arcana.lifetime',
    /** Shown until the store answers with the real, localised price. */
    lifetimeFallbackPrice: '$4.99',

    androidPackage: env.REACT_APP_ANDROID_PACKAGE || 'works.gago.arcana',
    androidLive: env.REACT_APP_ANDROID_LIVE === 'true',
    iosAppId: env.REACT_APP_IOS_APP_ID || '',

    supportEmail: env.REACT_APP_SUPPORT_EMAIL || 'support.arcana@gago.works',
};

export const webFooterAdConfigured = (): boolean =>
    Boolean(config.adsenseClient && config.adsenseFooterSlot) ||
    config.adsPreview;

export const webBreakAdConfigured = (): boolean =>
    Boolean(config.adsenseClient && config.adsenseBreakSlot) ||
    config.adsPreview;
